import React from "react";
import { StyleSheet, View } from "react-native";

import CustomText from "../../../common/general/CustomText/CustomText";
import type { ActiveRubricSetQuery } from "../../../../graphql/generated/graphql";

type RubricSetViewModel = NonNullable<ActiveRubricSetQuery["activeRubricSet"]["data"]>;
type RubricSectionViewModel = RubricSetViewModel["sections"][number];
type RubricCriterionViewModel = RubricSectionViewModel["criteria"][number];

interface RubricCriterionCardProps {
  criterion: RubricCriterionViewModel;
}

function RubricCriterionCard({ criterion }: RubricCriterionCardProps) {
  return (
    <View style={styles.criterionCard}>
      <View style={styles.criterionTitleRow}>
        {criterion.code ? (
          <CustomText
            text={criterion.code}
            size="xs"
            weight="bold"
            style={styles.criterionCode}
            useTranslationText={false}
          />
        ) : null}
        <CustomText
          text={criterion.title}
          size="xs"
          weight="medium"
          style={styles.criterionTitle}
          useTranslationText={false}
        />
      </View>
      <CustomText
        text={criterion.description}
        size="xs"
        style={styles.criterionDescription}
        useTranslationText={false}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  criterionCard: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    backgroundColor: "#F9FAFB",
    gap: 4,
  },
  criterionTitleRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 8,
  },
  criterionCode: {
    color: "#3459D4",
  },
  criterionTitle: {
    color: "#101828",
    flex: 1,
  },
  criterionDescription: {
    color: "#475467",
    lineHeight: 18,
  },
});

export default RubricCriterionCard;
